import { useParams, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { PAGES } from "../content/pages";
import { PageHero, Block, SupportCta } from "../components/pages/Blocks";

export default function ContentPage({ slug: fixed }) {
  const { slug: param } = useParams();
  const slug = fixed || param;
  const page = PAGES[slug];
  useEffect(() => {
    if (page) document.title = `${page.title} | Wings of Fire Foundation`;
  }, [page]);
  if (!page) return <Navigate to="/" replace />;
  return (
    <div data-testid={`page-${slug}`}>
      <PageHero eyebrow={page.eyebrow} title={page.title} intro={page.intro} image={page.image} />
      {page.blocks.map((b, i) => (
        <Block key={`${b.type}-${i}`} block={b} />
      ))}
      {page.support && <SupportCta />}
    </div>
  );
}
